import { MenuApi } from '../../api-clients';
import { wrap } from '../../wrap';

export const menuSetApi = {
  index: wrap(MenuApi, MenuApi.prototype.indexMenuSetList),
  show: wrap(MenuApi, MenuApi.prototype.showMenuSet),
  create: wrap(MenuApi, MenuApi.prototype.createMenuSet),
  update: wrap(MenuApi, MenuApi.prototype.updateMenuSet),
};
